<template>
  <div class='stockpile' v-loading='importLoading'>
    <div class='nav' >
      <el-form :model='form' label-width='130px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='供应商：'>
          <el-input v-model='form.supplierName' size='mini' placeholder='请输入供应商名称'/>
        </el-form-item>
        <el-form-item label='委托商名称：'>
          <el-input v-model='form.consignorName' size='mini' placeholder='请输入委托商名称称'/>
        </el-form-item>
        <el-form-item label='台账月：'>
          <el-input v-model='form.standingBookMonth' size='mini' placeholder='请输入台账月'/>
        </el-form-item>
        <el-form-item label='批次号：'>
          <el-input v-model='form.batchNumber' size='mini' placeholder='请输入批次号'/>
        </el-form-item>
        <el-form-item label='运单编号：'>
          <el-input v-model='form.waybillNo' size='mini' placeholder='请输入运单编号'/>
        </el-form-item>
        <el-form-item label='车架号：'>
          <el-input v-model='form.frameNumber' size='mini' placeholder='请输入车架号'/>
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='form.brandName' size='mini' placeholder='请输入品牌名称'/>
        </el-form-item>
        <el-form-item label='是否生成对账单：'>
          <el-select size='mini' filterable v-model='form.isReconciliation'
                     placeholder='请选择是否生成对账单'>
            <el-option label='全部' value=''/>
            <el-option label='是' :value='1'/>
            <el-option label='否' :value='0'/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='addResetBtn'>刷新结算</el-button>
          <!--          <el-button size='small' type='primary' @click='ledgerRevise'>修改台账月</el-button>-->
          <el-button size='small' type='primary' @click='priceRefresh'>价格刷新</el-button>
        </el-form-item>

      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
        <import-statement @getList='_farePageList' @changeImportLoading='changeImportLoading'
                          :type='9'/>
        </span>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          tooltip-effect='dark'
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            'height': '48px',
            background: '#E8E8E8'
          }"
          :row-key='(row)=>{return row.id}'
          :cell-style="{height:'42px',}"
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px'
                           :selectable='(row,index)=>{return row.isReconciliation !==1}'
                           :reserve-selection='true'/>
          <el-table-column prop='supplierName' align='center' label='供应商' width='130px'
                           show-overflow-tooltip/>
          <el-table-column align='center' label='供应商类型' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.supplierType ? '水路' : '公路' }}
            </template>
          </el-table-column>
          <el-table-column prop='standingBookMonth' align='center' label='台账月'
                           show-overflow-tooltip/>
          <el-table-column prop='pickDate' align='center' label='提车时间' width='130px'
                           show-overflow-tooltip/>
          <el-table-column align='center' label='提车地' show-overflow-tooltip width='130px'>
            <template slot-scope='scope'>
              {{
                scope.row.regionType ? scope.row.portName : scope.row.regionName
              }}
            </template>
          </el-table-column>
          <el-table-column prop='consignorName' align='center' label='委托商名称' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='batchNumber' align='center' label='批次号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='waybillNo' align='center' label='运单编号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='frameNumber' align='center' label='车架号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='brandName' align='center' label='品牌' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='modelName' align='center' label='型号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='taxRate' align='center' label='税率' show-overflow-tooltip/>
          <el-table-column prop='taxPrice' align='center' label='含税单价' show-overflow-tooltip/>
          <el-table-column prop='price' align='center' label='不含税单价' show-overflow-tooltip/>
          <el-table-column label='生成对账单' align='center'>
            <template slot-scope='scope'>{{ scope.row.isReconciliation ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop='actNo' label='对账单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[50, 100, 500, 1000,5000]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <!-- 对账单 -->
    <el-dialog
      :title="importShow ? '导入生成对账单' : '生成对账单'"
      :visible.sync='addFlag'
      width='950'
      center
      @close='dialogClose'>
      <storeroom-account
        @closeDialogAndSearch='closeDialogAndSearch'
        :import-show='importShow'
        ref='accountState'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单信息</template>
        <template slot='label3'>其他费用</template>
      </storeroom-account>
    </el-dialog>
    <el-dialog title='添加其他费用' :visible.sync='otherAddFlag' append-to-body width='750px'>
      <otherAdd @otherDataCelect='otherData' ref='otherAdds'
                :otherDateProps='JSON.parse(JSON.stringify(otherTableData))'
                :consignor-id='consignorId'></otherAdd>
    </el-dialog>

    <el-dialog :title='dialogTitle' :visible.sync='newlyAddShow' width='650px' center
               @close='newlyAddDialogClose'>
      <div class='modifyData'>
        <div-border label='基础信息' prop='plan' style='padding: 20px'>
          <el-form :model='modifyData' label-width='110px' label-position='right' :rules='rules'
                   ref='ruleForm' class='demo-ruleForm'>
            <el-form-item label='库房名称：' prop='StorageRoomName'>
              <el-input v-model='modifyData.StorageRoomName' size='mini'
                        placeholder='请输入库房名称'></el-input>
            </el-form-item>
            <el-form-item label='费用类型：' prop='costType'>
              <el-select v-model='modifyData.costType' filterable size='mini'
                         placeholder='请选择费用类型'
                         value-key='id'>
                <el-option v-for='(item,index) in costTypeOpiton' :key='item.id'
                           :label='item.classaName' :value='item'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='费用时间：' prop='costTime'>
              <el-date-picker
                v-model='modifyData.costTime'
                type='datetime'
                placeholder='选择日期时间'
                size='mini'
                value-format='yyyy-MM-dd HH:mm:ss'
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label='结算模式：' prop='settlementMode'>
              <el-select v-model='modifyData.settlementMode' filterable size='mini'
                         placeholder='请选择结算模式' value-key='id'>
                <el-option v-for='(item,index) in settlementMode' :key='item.id'
                           :label='item.classaName' :value='item'></el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-col :span='10'>

                <el-form-item label='不含税合同价：' prop='contractPrice'>
                  <el-input
                    style='width: 120px;'
                    v-model='modifyData.contractPrice'
                    placeholder='请输入不含税合同价'
                    size='mini'
                  >
                    <span slot='suffix' style='color: #999'>|  元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span='10'>
                <el-form-item label='含税合同价：' prop='taxContractPrice'>
                  <el-input
                    style='width: 120px;'
                    v-model='modifyData.taxContractPrice'
                    placeholder='请输入含税合同价'
                    size='mini'
                  >
                    <span slot='suffix' style='color: #999'>|  元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='税率%：' prop='taxRate'>
                  <el-input
                    style='width: 115px;'
                    v-model='modifyData.taxRate'
                    placeholder='请输入税率'
                    size='mini'
                  >
                    <span slot='suffix' style='color: #999'>|  %</span>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--            <el-form-item label="是否生成对账单：" prop="isReconciliation" label-width="125px">-->
            <!--              <el-radio-group v-model="modifyData.isReconciliation">-->
            <!--                <el-radio :label="1">否</el-radio>-->
            <!--                <el-radio :label="2">是</el-radio>-->
            <!--              </el-radio-group>-->
            <!--            </el-form-item>-->
            <el-form-item style='display: flex;    justify-content: center;' label-width='0px'>
              <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>
                {{ dialogTitle === '新增库房结算' ? '添加' : '修改' }}
              </el-button>
              <el-button size='medium' class='resetBtn' @click='newlyAddDialogClose'>关闭
              </el-button>
            </el-form-item>
          </el-form>
        </div-border>

      </div>


    </el-dialog>

    <!-- 修改台账月 -->
    <el-dialog title='修改台账月' :visible.sync='ledgerVisible' width='1050px' center
               @close='ledgerClose'>
      <div class='ledger'>
        <div class='leader-input'>
          <span>请输入台账月：</span>
          <el-input style='display:inline-block' size='small' type='text' v-model='ledger'/>
          <div style='display:inline-block;width:calc(100% - 300px);text-align:right'>
            <el-button size='small' class='searchBtn' @click='ledgerChange'>确 定</el-button>
            <el-button size='small' class='resetBtn' @click='ledgerClose'>取 消</el-button>
          </div>
        </div>
        <el-table
          v-loading='ledgerLoad'
          :data='ledgerData'
          style='width: 100%'
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column prop='supplierName' align='center' label='供应商名称' width='130px'
                           show-overflow-tooltip/>
          <el-table-column align='center' label='供应商类型' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.supplierType ? '水路' : '公路' }}
            </template>
          </el-table-column>
          <el-table-column prop='standingBookMonth' align='center' label='台账月'
                           show-overflow-tooltip/>
          <el-table-column prop='pickDate' align='center' label='提车时间' width='130px'
                           show-overflow-tooltip/>
          <el-table-column align='center' label='提车地' show-overflow-tooltip width='130px'>
            <template slot-scope='scope'>
              {{
                scope.row.regionType ? scope.row.portName : scope.row.regionName
              }}
            </template>
          </el-table-column>
          <el-table-column prop='consignorName' align='center' label='委托商名称' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='batchNumber' align='center' label='批次号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='waybillNo' align='center' label='运单编号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='frameNumber' align='center' label='车架号' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='brandName' align='center' label='品牌名称' width='130px'
                           show-overflow-tooltip/>
          <el-table-column prop='modelName' align='center' label='型号名称' width='130px'
                           show-overflow-tooltip/>
          <el-table-column label='操作' width='60px' align='center'>
            <template slot-scope='scope'>
              <i class='el-icon-error' style='font-size: 20px;'
                 @click='delLedger(scope.$index)'></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import otherAdd from '@/views/settle/supplier/components/otherAdd.vue';
  import storeroomAccount from '@/views/settle/supplier/components/storeroomAccount.vue';
  import {
    getParam,
    farePageList,
    warehouseAddWarehouse,
    customerAdd,
    deductionInvoicingCostGetAllByCompanyId,
    fareUpdateBatchStandingBookMonth,
    fareRefreshSettlement,
  } from '@/service/getData';
  import {formatTime, getSessionStore} from '@/config/mUtils';
  import {baseUrl} from '@/config/env';
  import ImportStatement from '@/views/settle/entrust/components/import-statement';
  import {supplierHandoverPriceRefresh} from '@/service/basicfile';

  export default {
    components: {
      ImportStatement,
      otherAdd,
      storeroomAccount,
    },

    data() {
      return {
        form: {
          supplierName: '', // 供应商名称
          consignorName: '', // 委托商名称
          standingBookMonth: '', // 台账月
          batchNumber: '', // 批次号
          waybillNo: '', // 运单编号
          frameNumber: '', // 车架号
          brandName: '', // 品牌名称
          isReconciliation: '', // 是否生成对账单 0：否 1：是
          page: 1,
          rows: 50,
        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        checkList: [], // 导入生成账单 选择数据
        visible: false, // 导入生成账单 筛选条件显示

        importShow: false,
        activeName: 'information', // 标签页
        otherAddFlag: false,
        isDisabled: false, // 是否启用合同价
        InvoicingList: [], // 抵扣费用下拉
        consignorId: '', // 公司id
        informationData: {
          supplier: '', // 供应商
          // Settlement:'',//结算方式
          sumIncluded: '', // 合计含税费用
          sumNotIncluded: '', // 合计不含税费用
          title: '', //
          isInvoicing: 0, // 是否抵扣开票
          Invoicing: '', // 选择抵扣费用
          Deductible: '', // 抵扣费用
          remark: '',
        },
        checkLoad: false,
        notTableData: [],
        otherTableData: [],
        checkTableData: [],
        otherIncluded: 0, // 其他费用合计
        otherNotIncluded: 0, // 其他费用合计
        sumContract: 0, // 作业费用合计
        sumNotIncluded: 0,
        sumBudget: 0,
        sumNotBudget: 0,
        oldSupplier: '', // 原供应商
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],

        addFlag: false,
        dialogTitle: '', // 新增标题
        addLoad: false,
        newlyAddShow: false, // 新增显示
        // 新增修改数据
        modifyData: {
          StorageRoomName: '', // 库房名称
          costType: '', // 费用类型
          costTime: '', // 费用时间
          settlementMode: '', // 结算模式
          taxRate: '', // 税率
          taxContractPrice: '', // 含税合同价
          contractPrice: '', // 不含税合同价
          isReconciliation: '', // 是否生成对账单
        },
        costTypeOpiton: [], // 费用类型下拉
        settlementMode: [], // 结算模式下拉
        rules: {
          plan: {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
          name: [
            {
              required: true,
              message: '请输入业务名称',
              trigger: 'blur',
            },
            {
              min: 3,
              max: 9,
              message: '长度在 3 到 9 个字符',
              trigger: 'blur',
            },
          ],
          StorageRoomName: {
            required: true,
            message: '请输入库房名称',
            trigger: 'blur',
          },
          costType: {
            required: true,
            message: '请选择费用类型',
            trigger: 'blur',
          },
          costTime: {
            required: true,
            message: '选择日期时间',
            trigger: 'blur',
          },
          settlementMode: {
            required: true,
            message: '请选择结算模式',
            trigger: 'blur',
          },
          contractPrice: {
            required: true,
            message: '请输入不含税合同价',
            trigger: 'blur',
          },
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          taxContractPrice: {
            required: true,
            message: '请输入含税合同价',
            trigger: 'blur',
          },
          isReconciliation: {
            required: true,
            message: '请选择是否生成对账单',
            trigger: 'blur',
          },
          type: {
            required: true,
            message: '请选择评审类型',
            trigger: 'blur',
          },
          img: {
            required: true,
            message: '请选择合同照片',
            trigger: 'blur',
          },

          title: {
            required: true,
            message: '请输入对账单标题',
            trigger: 'blur',
          },
          isInvoicing: {
            required: true,
            message: '请选择是否抵扣开票',
            trigger: 'blur',
          },
          Invoicing: {
            required: true,
            message: '请选择抵扣费用数据',
            trigger: 'blur',
          },
          Deductible: {
            required: true,
            message: '请输入抵扣费用',
            trigger: 'blur',
          },

        },
        // 修改台账月
        ledgerVisible: false,
        ledgerLoad: false,
        ledger: '',
        ledgerData: [],
        importLoading: false,
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      sumIncluded() {

      },
    },
    watch: {
      checkTableData(val) {
        console.log(val);
        this.sumContract = this.calculation(val, 'contactPriceWithTax');

        this.sumNotIncluded = this.calculation(val, 'contactPriceWithoutTax');

        // 合计含税费用
        this.sumCost();

        this.decideContract(val, this.otherTableData);
        // 保存原始库房名称
        this.informationData.supplier = this.checkTableData[0].warehouseName;
        this.oldSupplier = this.checkTableData[0].warehouseName;
      },
      otherTableData(val) {
        this.otherIncluded = this.calculation(val, 'costAmount');
        this.otherNotIncluded = this.calculation(val, 'excludingTaxAmount');
        // 合计含税费用
        this.sumCost();


        this.decideContract(this.checkTableData, val);
      },
    },
    filters: {
      isGenerateBillFormat(value) {
        switch (value) {
          case 0:
            return '否';
          case 1:
            return '是';
        }
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd ');
        }
        return '';
      },
    },
    mounted() {
      // this._farePageList();
      // this._planType();
    },
    methods: {
      // 导出数据
      exportData() {
        let params = {
          ...this.form,
          frameNumber: this.form.frameNumber.replace(/\s+/g,',')
        };
        let token = getSessionStore('token');
        window.exportExcel(`${baseUrl}/platform/settlement/supplierHandover/exportXls?access_token=${token}`, params, '供应商提车费结算');
      },
      async _farePageList() {
        this.tableLoad = true;
        const res = await farePageList({
          ...this.form,
          frameNumber: this.form.frameNumber.replace(/\s+/g,',')
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.total = res.data.total;
        this.TableDatas = res.data.records;
      },
      compareDate(d1, d2) {
        return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
      },
      // 结束时间
      dateChange(val) {
        if (this.form.costTime[1] && this.form.costTime[0] && this.compareDate(this.form.costTime[0], this.form.costTime[1])) {
          if (val == this.form.costTime[1]) this.form.costTime[1] = '';
          if (val == this.form.costTime[0]) this.form.costTime[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 查询费用类型 结算模式
      async _planType() {
        // 查询费用类型
        const res = await getParam({ categoryCd: 'torage_room' });
        if (res.status !== 0) return this.$message.error(res.message);
        this.costTypeOpiton = res.data.map(item => ({
          classaName: item.classaName,
          id: item.id,
        }));
        console.log(this.typeOpiton);
        // 结算模式
        const res2 = await getParam({ categoryCd: 'settlement_pattern' });
        if (res2.status !== 0) return this.$message.error(res2.message);
        this.settlementMode = res2.data;
      },
      // 生成对账单
      async _customerAdd() {
        const {
          supplier,
          sumIncluded,
          sumNotIncluded,
          title,
          isInvoicing,
          Invoicing,
          Deductible,
          remark,
          Settlement,
        } = this.informationData;
        let settIds = '';
        this.checkTableData.forEach((item, index) => {
          // 最后一个不加逗号
          settIds += index === this.checkTableData.length - 1 ? item.id : `${item.id},`;
        });
        let otherCostIds = '';
        this.otherTableData.forEach((item, index) => {
          // 最后一个不加逗号
          otherCostIds += index === this.otherTableData.length - 1 ? item.id : `${item.id},`;
        });
        const obj = {
          companyId: this.consignorId,
          // companyNameOld:this.oldSupplier,
          companyNameNew: supplier,
          taxPrice: Number(sumIncluded),
          noTaxPrice: Number(sumNotIncluded),
          title,
          isDeduct: isInvoicing,
          deductId: Invoicing.id,
          deductAmount: Deductible,
          remark,
          type: 9, // 库房结算
          settIds: this.checkTableData.length > 0 ? settIds : '',
          otherCostIds: this.otherTableData.length > 0 ? otherCostIds : '',
        };
        const res = await customerAdd(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._refuelingpowerList();
        this.dialogClose();
        await this._farePageList();
      },
      // 抵扣费用下拉
      async _deductionInvoicingCostGetAllByCompanyId(id) {
        const res = await deductionInvoicingCostGetAllByCompanyId(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.InvoicingList = res.data.map(item => ({
          id: item.id,
          deductionNum: item.deduction_num,
          remainingDiscountAmount: item.remaining_discount_amount,
        }));
      },
      // 生成对账单按钮
      addBtn() {
        if (this.checkTableData.length === 0) return this.$message.warning('请至少选择一条结算数据！');
        let supplierFlag = false; // 供应商
        let taxFlag = false; // 税率
        let reconciliationFlag = false; // 是否生成对账单
        if (this.checkTableData.length > 0) {
          const {
            supplierId,
            taxRate,
          } = this.checkTableData[0];
          this.checkTableData.forEach((item) => {
            if (item.supplierId !== supplierId) {
              supplierFlag = true;
            }
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
            if (item.isReconciliation) {
              reconciliationFlag = true;
            }
          });
        }
        if (supplierFlag) return this.$message.warning('只能选择同一家供应商数据！');
        if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');
        this.addFlag = true;
        this.$nextTick(() => {
          // 传入表格数据
          this.$refs.accountState.init(this.checkTableData);
        });
        this.importShow = false;
      },
      // 刷新结算按钮
      async addResetBtn() {
        if (!this.form.consignorName) return this.$message.warning('请输入委托商名称后刷新结算！');
        this.tableLoad = true;
        // 接口需修改
        const {
          status,
          message,
        } = await fareRefreshSettlement({ consignorName: this.form.consignorName });
        this.tableLoad = false;
        status === 0 ? this.$message.success(message) : this.$message.error(message);
        this.searchBtn();
      },
      // 合计含税费用
      sumCost() {
        // 合计含税
        this.informationData.sumIncluded = this.sumContract + this.otherIncluded;
        // 合计不含税
        this.informationData.sumNotIncluded = this.sumNotIncluded + this.otherNotIncluded;
      },
      searchBtn() {
        this.form.page = 1;
        this._farePageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.costTime = ['', ''];
        this.form.page = 1;
        this.form.rows = 10;
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._farePageList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._farePageList();
      },

      getSummaries(param) {
        const {
          columns,
          data,
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
          } else if (index >= 11) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => prev + curr, 0);
            }
            console.log(column);
          }
        });
        return sums;
      },
      // deleteClick(index) {
      //   this.checkTableData2.splice(index, 1);
      // },
      // 导入
      importClick(index, row) {
        if (this.checkList.length < 3) return this.$message.warning('至少选择3个条件');
        this.visible = false;
        this.importShow = true;
        this.addFlag = true;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;

        let Waybill = '';
        const array = val.filter((item, index) => {
          if (index === 0) Waybill = item.warehouseName;
          return Waybill !== item.warehouseName;
        });
        // 筛选  供应商相同数据
        this.checkTableData = val.filter(item => Waybill === item.warehouseName);
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          this.$message.warning('只能选择相同的供应商');
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });

        // this.$refs.accountState.calculation()
      },
      handleCurrentChangeAll(val) {
        this.checkTableData = val;
        console.log(val);
        console.log(this.checkTableData);

        // this.$refs.accountState.calculation()
      },
      tableRowClassName({ row }) {
        if (this.sumContract !== this.sumNotIncluded && this.importShow) {
          return 'ui-warning-row';
        }
        return '';
      },

      selectChange() { // 勾选
        // 先清空选择
        this.$refs.multipleTable.clearSelection();
        this.$nextTick(() => {
          this.checkTableData.forEach((row) => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
          });
        });
      },
      dialogClose() {
        this.activeName = 'information';
        this.addFlag = false;// 关闭窗口
        // 清空
        for (const informationDataKey in this.informationData) {
          this.informationData[informationDataKey] = '';
        }
        // 清除提示
        this.$refs.ruleForm.resetFields();
      },
      calculation(table, zi) {
        let sum = 0;
        table.forEach((item, index) => {
          sum += Number(item[zi]);
          console.log(sum);
        });
        return sum;
      },
      deleteClick(index, flag) {
        if (flag === 1) {
          const array = this.checkTableData.splice(index, 1);

          array.forEach((item) => {
            this.notTableData.push(item);
          });
          console.log(this.notTableData);
          this.selectChange();
        } else {
          this.otherTableData.splice(index, 1);
          this.$refs.otherAdds.toggleSelection();
        }
      },
      otherAddClick() {
        this.consignorId = this.checkTableData.length > 0 ? this.checkTableData[0].portId : '';
        this.otherAddFlag = true;
        this.$nextTick(() => {
          this.$refs.otherAdds._othercostGetAllByCompanyId();
        });
      },
      otherData(value) {
        this.otherTableData = value;
      },
      addWaybill(index) {
        const a = this.notTableData.splice(index, 1);
        this.checkTableData.push(a[0]);
        this.selectChange();
      },
      //  判断 不/含税合同价是否为空  value  value2其他费用
      decideContract(value, value2) {
        let flag = true;
        value.forEach((item, index) => {
          if (item.contactPriceWithTax === null || item.contactPriceWithoutTax === null) {
            // 是否禁用选项
            this.isDisabled = true;
            flag = false;
            console.log(this.isDisabled);
            this.informationData.Settlement = 2;
            throw new Error('不/含税合同价为空');
          } else {
            flag = true;
          }
        });
        value2.forEach((item) => {
          if (item.costAmount === null || item.excludingTaxAmount === null) {
            // 是否禁用选项
            this.isDisabled = true;
            flag = false;
            console.log(this.isDisabled);
            this.informationData.Settlement = 2;
            // 终止foreach 并且不执行后面的代码
            throw new Error('不/含税合同价为空');
          } else {
            flag = true;
          }
        });

        if (flag) {
          this.isDisabled = false;
        }
      },
      // 新增
      newlyAdd() {
        this.dialogTitle = '新增库房结算';
        this.newlyAddShow = true;
      },
      // 新增库房结算 关闭窗口
      newlyAddDialogClose() {
        // 清空提示
        this.$refs.ruleForm.resetFields();
        // 数据清空
        for (const argumentsKey in this.modifyData) {
          this.modifyData[argumentsKey] = '';
        }
        this.newlyAddShow = false;
      },
      // 新增库房结算 添加
      addClick() {
        this.$refs.ruleForm.validate(async (valid) => {
          const {
            StorageRoomName,
            costType,
            costTime,
            settlementMode,
            contractPrice,
            taxContractPrice,
            taxRate,
            id,
          } = this.modifyData;
          const obj = {
            id: id || '',
            warehouseName: StorageRoomName,
            expenseId: costType.id,
            expenseName: costType.classaName,
            expenseTime: costTime,
            settlementModeId: settlementMode.id,
            settlementModeName: settlementMode.classaName,
            taxRate: Number(taxRate),
            contactPriceWithTax: Number(taxContractPrice),
            contactPriceWithoutTax: Number(contractPrice),
          };
          if (valid) {
            this.addLoad = true;
            const res = await warehouseAddWarehouse(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._farePageList();
            this.newlyAddDialogClose();
          }
        });
      },
      // 修改
      changeClick(row) {
        const {
          warehouseName,
          expenseId,
          expenseName,
          expenseTime,
          settlementModeId,
          settlementModeName,
          taxRate,
          contactPriceWithTax,
          contactPriceWithoutTax,
        } = row;
        this.dialogTitle = '修改库房结算';
        this.newlyAddShow = true;

        this.modifyData = {
          id: row.id ? row.id : '',
          StorageRoomName: warehouseName, // 库房名称
          costType: {
            id: expenseId,
            classaName: expenseName,
          }, // 费用类型
          costTime: expenseTime, // 费用时间
          settlementMode: {
            id: settlementModeId,
            classaName: settlementModeName,
          }, // 结算模式
          taxRate, // 税率
          taxContractPrice: contactPriceWithTax, // 含税合同价
          contractPrice: contactPriceWithoutTax, // 不含税合同价
        };
      },
      // 生产对账点 确认
      accountAdd() {
        if (this.checkTableData.length <= 0) return this.$message.warning('作业费用不能为空');
        if (this.otherTableData.length <= 0) return this.$message.warning('其他费用不能为空');
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this._customerAdd();
          } else {

          }
        });
      },
      // 是否抵扣开票
      isInvoicingChange(value) {
        const id = this.checkTableData.length > 0 ? this.checkTableData[0].portId : '';
        if (value === 1) {
          this._deductionInvoicingCostGetAllByCompanyId(id);
        }
      },
      // 价格刷新
      async priceRefresh() {
        this.importLoading = true;
        const {
          status,
          message,
        } = await supplierHandoverPriceRefresh();
        this.importLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
      },
      // 修改台账月 -- 打开弹窗
      ledgerRevise() {
        if (!this.checkTableData.length || this.checkTableData.length == 0) return this.$message.error('请选择至少一条数据！');
        if (this.checkTableData.length > 100) return this.$message.error('最多选择100条数据！');
        this.ledgerData = this.checkTableData;
        this.ledgerVisible = true;
      },
      // 修改台账月 -- 删除
      delLedger(index) {
        this.ledgerData.splice(index, 1);
      },
      // 修改台账月 -- 确认
      async ledgerChange() {
        const params = {
          standingBookMonth: this.ledger,
          handoverList: [],
        };
        this.ledgerData.forEach((res) => {
          params.handoverList.push({ id: res.id });
        });
        await fareUpdateBatchStandingBookMonth(params)
          .then((res) => {
            if (res.status === 0) {
              this.$message.success(res.message);
              this.ledgerVisible = false;
              this.searchBtn();
            } else {
              this.$message.error(res.message);
            }
          });
      },
      // 修改台账月 -- 取消(关闭弹窗)
      ledgerClose() {
        this.ledger = '';
        this.ledgerData = [];
        this.ledgerVisible = false;
      },
      // 关闭弹窗并刷新页面
      closeDialogAndSearch() {
        this.dialogClose();
        this.searchBtn();
      },
      download() {
        window.location.href = '/file/供应商导入模板.xlsx';
      },
      changeImportLoading(flag) {
        this.importLoading = flag;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .stockpile {
    width: 100%;
    padding: 20px 15px 0 25px;
    height: 100%;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 460px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-right: 250px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .exportButton {
      span {
        color: rgba(51, 136, 255, 1);
        font-size: 14px;
        margin-right: 10px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }

    ::v-deep.content {
      .el-table .cell, .el-table td {
        padding: 0;
      }

    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .importBill {
      width: 100%;
      padding: 10px 16px 20px 20px;

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      .el-table td, .el-table th {
        padding: 0;
      }

      .el-tabs__item.is-active {
        color: #335483
      }

      .el-tabs__item {
        font-weight: bold !important;
      }

      cell {
        font-size: 10px;
        padding: 0;
      }

      .el-table .ui-warning-row {
        background-color: #fef0f0 !important;
      }

      .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
        background-color: #fef0f0 !important;
      }

      .el-table .ui-warning-row .cell {
        color: red;
      }

      .information {
        /*width: 83%;*/
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input {
          width: 56%;
        }

        .el-form-item {
          margin-bottom: 9px;
        }

        .costList {
          .el-input {
            width: 100%;
          }
        }

        .icon {
          color: red;
          font-size: 20px;
          margin-left: 20px;

          span {
            font-size: 15px;
          }
        }

      }

      .cost {
        .iconError {
          font-size: 20px;

          i:hover {
            color: #00e1ff;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;

          .el-button--mini {
            padding: 4px 4px;
          }
        }
      }

      .otherCost {
        .total {
          .otherAdd {
            color: rgba(51, 136, 255, 1);
            text-align: right;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }

    ::v-deep.modifyData {
      padding: 20px;

      .el-form-item {
        .el-input {
          width: 333px;
        }
      }
    }


  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-form--inline .el-form-item {
      margin-bottom: 5px;
    }

  }

  .stockpile .importBill .operation {
    margin-top: 0px !important;
    padding: 0px;
  }

  .stockpile .importBill .operationTable {
    padding-right: 0px !important;
  }

  .ledger {
    padding: 20px;

    .leader-input {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      span {
        display: inline-block;
        width: 100px;
      }

      ::v-deep {
        .el-input.el-input--small {
          display: inline-block;
          width: 200px;
        }
      }
    }

    ::v-deep {
      .el-table td {
        padding: 5px;
      }

      .el-table td, .el-table th {
        font-size: 13px;
        padding: 5px;
      }
    }
  }
</style>
